import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from 'react-router-dom'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useSidebar } from '../sidebar-context'

function SidebarLink({ path, title, icon, onNavigate }) {
  const currentPath = window.location.pathname
  const navigate = useNavigate()
  const { isCollapsed, isMobile } = useSidebar()
  const iconsOnly = isCollapsed && !isMobile

  const handleNavigate = (e) => {
    e.preventDefault()
    if (onNavigate) onNavigate()
    navigate(`/${path}`)
  }

  const isActive = currentPath.includes(path)

  const withTooltip = (element) => {
    if (!iconsOnly) return element
    return (
      <OverlayTrigger
        placement="right"
        delay={{ show: 200, hide: 0 }}
        overlay={<Tooltip id={`sidebar-tooltip-${path}`}>{title}</Tooltip>}
      >
        {element}
      </OverlayTrigger>
    )
  }

  return (
    <li
      className={`nav-item ${
        isActive ? 'border-right border-primary' : ''
      }`}
    >
      {withTooltip(
        <a
          className={`nav-link access-management-nav-link ${
            isActive ? 'active' : 'fw-light'
          } ${iconsOnly ? 'nav-link-icon-only' : ''}`}
          data-testid={`sidebar-link-${path}`}
          href={`/${path}`}
          onClick={handleNavigate}
          aria-label={title}
        >
          <FontAwesomeIcon
            className={isActive ? '' : 'feather'}
            style={{ minWidth: '30' }}
            icon={icon}
          />{' '}
          {!iconsOnly && title}
        </a>
      )}
    </li>
  )
}

export default SidebarLink
